export const ok = value => ({
  type: 'ok',
  value
});
export const error = err => ({
  error: err,
  type: 'error'
});
export const isError = result => {
  return result.type === 'error';
};